import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { IOurEntity } from 'wisestep-api';
import { WsButton, WsColors, WsTypography, WsTypoColors, WsIconEdit } from 'wisestep-base';

import { OurEntityAction, useOurEntityAuthz } from '../../../hooks/useOurEntityAuthz';

interface OurEntityDetailProps {
  labelText?: string;
  ourEntityData: IOurEntity;
}
const ShowOurEntityDetail = ({ labelText, ourEntityData }: OurEntityDetailProps) => {
  const isAuthorizedEditOurEntity = useOurEntityAuthz(OurEntityAction.EDIT_ENTITY_DETAILS);
  const GridItem = styled(Grid)(() => ({
    background: WsColors.White,
    border: '1px solid rgba(224, 224, 224, 1)',
    borderRadius: '5px',
    padding: '20px',
  }));
  const navigate = useNavigate();

  const navigateToEditClient = () => navigate(`/organisationEntity/${ourEntityData.id}/edit`);

  return (
    <Grid item xs={12} spacing={2} mt={3}>
      <Box borderRadius={1.5}>
        <GridItem container>
          <Grid container sx={{ mt: 3 }}>
            <Grid item xs={12} container justifyContent="space-between">
              <WsTypography bold={true}>Organisation Entities Information</WsTypography>
              {isAuthorizedEditOurEntity && (
                <WsButton variant="text" startIcon={<WsIconEdit />} onClick={navigateToEditClient}>
                  {`Edit ${labelText}`}
                </WsButton>
              )}
            </Grid>
            <Grid md={4} p={2} display="flex">
              <Grid md={4}>
                <WsTypography color={WsTypoColors.SECONDARY}>Legal Name:</WsTypography>
              </Grid>

              <Grid md={4}>
                <WsTypography>{ourEntityData.Legal_Name}</WsTypography>
              </Grid>
            </Grid>
            <Grid md={4} p={2} display="flex">
              <Grid md={4}>
                <WsTypography color={WsTypoColors.SECONDARY}>Country:</WsTypography>
              </Grid>
              <Grid md={4}>
                <WsTypography>{ourEntityData.Country}</WsTypography>
              </Grid>
            </Grid>
            <Grid md={4} p={2} display="flex">
              <Grid md={8}>
                <WsTypography color={WsTypoColors.SECONDARY}>Organisation Time Zone:</WsTypography>
              </Grid>
              <Grid md={4}>
                <WsTypography>{ourEntityData.Timezone}</WsTypography>
              </Grid>
            </Grid>
            <Grid md={4} p={2} display="flex">
              <Grid md={4}>
                <WsTypography color={WsTypoColors.SECONDARY}>Registered Address:</WsTypography>
              </Grid>

              <Grid md={8}>
                <WsTypography>{ourEntityData.Registered_address}</WsTypography>
              </Grid>
            </Grid>
            <Grid md={4} p={2} display="flex">
              <Grid md={4}>
                <WsTypography color={WsTypoColors.SECONDARY}>Corporate Address:</WsTypography>
              </Grid>
              <Grid md={8}>
                <WsTypography>{ourEntityData.Corporate_address}</WsTypography>
              </Grid>
            </Grid>
          </Grid>
        </GridItem>
      </Box>
    </Grid>
  );
};

export default ShowOurEntityDetail;
